var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-title",domProps:{"textContent":_vm._s(_vm.$t('blocks.last_masterchain_blocks_title'))}}),_vm._v(" "),_vm._l((24),function(i){return _c('div',{staticClass:"card-row"},[(_vm.latestBlock)?_c('router-link',{attrs:{"to":{ name: 'block', params: {
                workchain: -1,
                shard: 8000000000000000,
                seqno: _vm.latestBlock - i,
            }}}},[_vm._v("\n                "+_vm._s(_vm.latestBlock - i)+"\n            ")]):_c('span',{staticClass:"skeleton"},[_vm._v("12345678")])],1)})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }